import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-objects-getters',
  slug: 'getters',
  title: 'A two-way temperature converter',
  type: 'code',
  estSeconds: 420,
  contentVersion: 1,
});
